module.exports = __webpack_public_path__ + "img/comochegar02.e3487ae2.jpg";